import React from "react";

export default function MockupPanel({ children, className = "" }) {
  return (
    <section
      className={[
        "relative overflow-hidden rounded-[32px]",
        "border border-[#ecdde8]/90",
        "bg-white/30 backdrop-blur-lg",
        "shadow-[0_24px_70px_rgba(15,23,42,0.09)]",
        className,
      ].join(" ")}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/72 via-pink-50/52 to-pink-100/34" />

      <div className="absolute -top-24 -right-20 h-[420px] w-[420px] rounded-full bg-pink-300/20 blur-[100px]" />
      <div className="absolute top-24 -left-32 h-[520px] w-[520px] rounded-full bg-pink-300/16 blur-[110px]" />

      <div
        className="absolute inset-0 opacity-45"
        style={{
          backgroundImage:
            "url('/assets/backgrounds/sparkle-overlay.png'), radial-gradient(rgba(236,72,153,0.08) 1px, transparent 1px), radial-gradient(rgba(236,72,153,0.05) 1px, transparent 1px)",
          backgroundSize: "cover, 100px 100px, 150px 150px",
          backgroundPosition: "center, 0 0, 60px 70px",
          backgroundRepeat: "no-repeat, repeat, repeat",
          maskImage: "radial-gradient(circle at 58% 38%, black 0%, transparent 74%)",
        }}
      />

      <div className="relative">{children}</div>
    </section>
  );
}
